import Fund from './fund.js';
import { AccountType, Payment } from './payment.js';
import User from './user.js';
import Vendor from './vendor.js';

export interface BankAccount {
  routingNumber: string;
  accountType: AccountType;
  accountNumber: string;
}

export enum PayeeType {
  User = 'User',
  Vendor = 'Vendor',
}

export type Payee =
  | (User & { payeeType: PayeeType.User })
  | (Vendor & { payeeType: PayeeType.Vendor });

export type PayeeInput = Payee & { fund: Fund };

export interface UpdatePayeeInput {
  payee: Pick<Payee, 'id' | 'payeeType'>;
  update: Partial<PayeeInput>;
}

export type PrepaidCardType = 'physicalCard' | 'virtualCard';

export interface PrepaidCardAccount {
  id: string;
  type: PrepaidCardType;
  createdAt: Date;
  fundReferenceId?: string;
  fund?: Fund;
  scheduleReferenceIds?: string[];
  paymentReferenceIds?: string[];
  payments?: Payment[];
  keys?: { cardId: string };
}

export interface RemoveAccountInput {
  id: string;
}
export interface AccountFilter {
  payeeId: string;
  fundIds?: string[];
  types?: PrepaidCardType[];
}
